import { render, staticRenderFns } from "./Duanxin.vue?vue&type=template&id=a2e160b4&scoped=true"
import script from "./Duanxin.vue?vue&type=script&lang=js"
export * from "./Duanxin.vue?vue&type=script&lang=js"
import style0 from "./Duanxin.vue?vue&type=style&index=0&id=a2e160b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e160b4",
  null
  
)

export default component.exports